document.addEventListener("DOMContentLoaded", () => {
  var KLAVIYO_COMPANY_ID = "SjrQpB";

  // Read configurable text from theme settings
  var config = window.klaviyoBisConfig || {};
  var popupText = config.popupText || "Register to receive an email when this item comes back in stock.";
  var checkboxLabel = config.checkboxLabel || "Sign Me Up For Emails About Offers Too!";

  // Submit BIS subscription to Klaviyo's client API
  async function subscribeToBis(email, variantId) {
    var response = await fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + KLAVIYO_COMPANY_ID + "&revamp=true",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-06-15",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: "$shopify:::$default:::" + variantId,
                },
              },
            },
          },
        }),
      }
    );
    return response.ok || response.status === 202;
  }

  // Subscribe to Klaviyo newsletter list
  async function subscribeToNewsletter(email) {
    await fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY_ID,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-06-15",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              custom_source: "Back in Stock Popup",
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "VYFBJw",
                },
              },
            },
          },
        }),
      }
    );
  }

  // Create and show the BIS popup form
  function showBisPopup(variantId, productTitle) {
    var existing = document.querySelector(".klaviyo-bis-popup");
    if (existing) existing.remove();

    var popup = document.createElement("div");
    popup.className = "klaviyo-bis-popup";
    popup.innerHTML = `
      <div class="klaviyo-bis-popup__overlay"></div>
      <div class="klaviyo-bis-popup__content">
        <button class="klaviyo-bis-popup__close" aria-label="Close">&times;</button>
        <h3 class="klaviyo-bis-popup__title">${productTitle}</h3>
        <p class="klaviyo-bis-popup__text">${popupText}</p>
        <form class="klaviyo-bis-popup__form">
          <input
            type="email"
            class="klaviyo-bis-popup__input"
            placeholder="Email Address"
            required
            autocomplete="email"
          />
          <label class="klaviyo-bis-popup__checkbox-label">
            <input type="checkbox" class="klaviyo-bis-popup__checkbox" checked />
            ${checkboxLabel}
          </label>
          <button type="submit" class="klaviyo-bis-popup__submit button">Notify Me When Available</button>
        </form>
        <div class="klaviyo-bis-popup__message" style="display:none;"></div>
      </div>
    `;

    document.body.appendChild(popup);

    var closeBtn = popup.querySelector(".klaviyo-bis-popup__close");
    var overlay = popup.querySelector(".klaviyo-bis-popup__overlay");
    var form = popup.querySelector(".klaviyo-bis-popup__form");
    var input = popup.querySelector(".klaviyo-bis-popup__input");
    var checkbox = popup.querySelector(".klaviyo-bis-popup__checkbox");
    var submitBtn = popup.querySelector(".klaviyo-bis-popup__submit");
    var message = popup.querySelector(".klaviyo-bis-popup__message");

    function closePopup() {
      popup.remove();
    }

    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!email) return;

      submitBtn.disabled = true;
      submitBtn.textContent = "Submitting...";

      try {
        var success = await subscribeToBis(email, variantId);

        if (checkbox.checked) {
          await subscribeToNewsletter(email);
        }

        if (success) {
          form.style.display = "none";
          message.style.display = "block";
          message.innerHTML =
            "You're registered! We'll let you know when it's back in stock." +
            '<a class="klaviyo-bis-popup__close-link">Close</a>';
          message.querySelector(".klaviyo-bis-popup__close-link").addEventListener("click", closePopup);
        } else {
          message.style.display = "block";
          message.classList.add("klaviyo-bis-popup__message--error");
          message.textContent = "Something went wrong. Please try again.";
          submitBtn.disabled = false;
          submitBtn.textContent = "Notify Me When Available";
        }
      } catch (err) {
        message.style.display = "block";
        message.classList.add("klaviyo-bis-popup__message--error");
        message.textContent = "Something went wrong. Please try again.";
        submitBtn.disabled = false;
        submitBtn.textContent = "Notify Me When Available";
      }
    });

    setTimeout(function () {
      input.focus();
    }, 100);
  }

  // Expose globally so buildProductCard and other scripts can use it
  window.showKlaviyoBisPopup = showBisPopup;

  // -- Intercept form submissions from sold-out product cards --
  document.addEventListener("submit", function (e) {
    var form = e.target;
    var productCard = form.closest("product-card");
    if (productCard && productCard.getAttribute("data-available") === "false") {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // -- Event delegation for product cards (catches static + dynamically added cards) --
  document.addEventListener("click", function (e) {
    // Find the clicked button (or its parent if the span was clicked)
    var button = e.target.closest(".quick-add__submit, .product-form__submit.add-to-cart");
    if (!button) return;

    // Check if this button is inside a product-card element
    var productCard = button.closest("product-card");
    if (productCard) {
      var isAvailable = productCard.getAttribute("data-available");
      if (isAvailable === "false") {
        e.preventDefault();
        e.stopPropagation();

        var variantId = productCard.getAttribute("data-original-product-variant-id");
        var titleEl = productCard.querySelector("[id^='title-']");
        var productTitle = titleEl ? titleEl.textContent.trim() : "This Item";

        showBisPopup(variantId, productTitle);
        return;
      }
    }

    // Check if this is the product page submit button (sold out)
    if (button.classList.contains("product-form__submit") && button.getAttribute("data-sold-out") === "true") {
      e.preventDefault();
      e.stopPropagation();

      // Get variant ID from the hidden form input
      var form = button.closest("form, product-form");
      var variantInput = form ? form.querySelector(".product-variant-id") : null;
      var variantId = variantInput ? variantInput.value : null;

      // Get product title from the product page
      var titleEl = document.querySelector(".product__title h1, .product__title");
      var productTitle = titleEl ? titleEl.textContent.trim() : "This Item";

      if (variantId) {
        showBisPopup(variantId, productTitle);
      }
    }
  });

  // -- Product page: handle trigger-button param --
  var params = new URLSearchParams(window.location.search);
  if (params.get("trigger-button") === "true") {
    var variantInput = document.querySelector(".product-variant-id");
    var variantId = variantInput ? variantInput.value : null;
    var titleEl = document.querySelector(".product__title h1, .product__title");
    var productTitle = titleEl ? titleEl.textContent.trim() : "This Item";

    if (variantId) {
      params.delete("trigger-button");
      window.history.replaceState(
        {},
        "",
        window.location.pathname + (params.toString() ? "?" + params.toString() : "")
      );
      showBisPopup(variantId, productTitle);
    }
  }
});